import { isEmptyArray, isNullable } from '@app/utils'

import { SIZE } from '@app/constants'

import type { TableSize } from './types'

export const initSize = (toggledSizes?: TableSize[]) => (): TableSize => {
  if (!isNullable(toggledSizes) && !isEmptyArray(toggledSizes)) {
    return toggledSizes[0]
  }

  return SIZE.middle
}
